var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Liveview"},[_c('canvas',{ref:"canvas",attrs:{"canvas":"","width":_vm.canvasSize.width,"height":_vm.canvasSize.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }